"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventState = void 0;
class EventState {
    constructor(id, sequence, subject, args) {
        this.id = id;
        this.sequence = sequence;
        this.subject = subject;
        this.args = args;
    }
}
exports.EventState = EventState;
